export default "__VITE_ASSET__BmOaQU3o__"